import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  /* 登录 */
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login/Index.vue')
  },
  /* 字体图标库 */
  {
    path: '/icon',
    name: 'Icon',
    component: () => import('../views/Home/Icon.vue')
  },
  /* 分享页入口页面 */
  {
    path: '/index_share',
    name: 'Index_share',
    component: () => import('../views/Home/ShareIndex.vue')
  },
  /* 分享页路由 */
  {
    path: '/',
    component: () => import('../views/Layout/Index.vue'),
    redirect: '/error',
    children: [
      {
        path: 'home', // 默认子路由，只能有1个
        name: 'Home',
        component: () =>
          import('../views/Home/Index.vue')
      },
      {
        path: 'error', // 默认子路由，只能有1个
        name: 'Error',
        component: () =>
          import('../views/Error/Index.vue')
      },
      {
        path: '/activity_detail', //活动详情
        name: 'ActivityDetail',
        component: () =>
          import('../views/Activity/Detail/Index.vue')
      },
      {
        path: '/sign_up', //活动报名
        name: 'SignUp',
        component: () =>
          import('../views/Activity/SignUp/Index.vue')
      },
      {
        path: '/sign_in', //活动签到
        name: 'SignIn',
        component: () =>
          import('../views/Activity/SignIn/Index.vue')
      },
      {
        path: '/entries', //参赛作品
        name: 'Entries',
        component: () =>
          import('../views/Activity/Entries/Index.vue')
      },
      {
        path: '/my_entries', //我的作品
        name: 'MyEntries',
        component: () =>
          import('../views/Activity/MyEntries/Index.vue')
      },
      {
        path: '/entriy_detail', //作品详情
        name: 'EntriyDetail',
        component: () =>
          import('../views/Activity/Entriy/Index.vue')
      },
      {
        path: '/submit_works', //投稿
        name: 'SubmitWorks',
        component: () =>
          import('../views/Activity/SubmitWorks/Index.vue')
      },
      {
        path: '/update_works', //投稿修改
        name: 'UpdateWorks',
        component: () =>
          import('../views/Activity/UpdateWorks/Index.vue')
      },
      {
        path: '/raffle_detail', //抽奖详情
        name: 'raffleDetail',
        component: () =>
          import('../views/Raffle/Index.vue')
      },
      {
        path: '/vote_detail', //投票详情
        name: 'VoteDetail',
        component: () =>
          import('../views/Vote/Index.vue')
      },
      {
        path: '/live_detail', //直播详情
        name: 'LiveDetail',
        component: () =>
          import('../views/Live/Index.vue')
      },
      {
        path: '/news_detail', //图文情页
        name: 'NewsDetail',
        component: () =>
          import('../views/News/Index.vue')
      },
      {
        path: '/gallery_detail', //图集详情
        name: 'GalleryDetail',
        component: () =>
          import('../views/Gallery/Index.vue')
      },
      {
        path: '/special_detail', //专题详情
        name: 'SpecialDetail',
        component: () =>
          import('../views/Special/Index.vue')
      },
      {
        path: '/ad_detail', //广告详情
        name: 'AdvertsDetail',
        component: () =>
          import('../views/Adverts/Index.vue')
      },
      {
        path: '/video_detail', // 视频详情
        name: 'VideoDetail',
        component: () =>
          import('../views/Video/Index.vue')
      },
      {
        path: '/short_video_detail', // 短视频详情
        name: 'ShortVideoDetail',
        component: () =>
          import('../views/ShortVideo/Index.vue')
      },
      {
        path: '/questionnaire_detail', // 问卷调查
        name: 'QuestionnaireDetail',
        component: () =>
          import('../views/Questionnaire/Index.vue')
      },
      {
        path: '/answer_detail', // 答题
        name: 'AnswerDetail',
        component: () =>
          import('../views/Answer/Index.vue')
      },
      {
        path: '/audio_detail', // 音频详情
        name: 'AudioDetail',
        component: () =>
          import('../views/Audio/Index.vue')
      },
      {
        path: '/report_list', // 报料列表
        name: 'ReportList',
        component: () =>
          import('../views/Report/List/Index.vue')
      },
      {
        path: '/report_detail', // 报料详情
        name: 'ReportDetail',
        component: () =>
          import('../views/Report/Detail/Index.vue')
      },
      {
        path: '/report_new', // 新增报料
        name: 'ReportNew',
        component: () =>
          import('../views/Report/New/Index.vue')
      },
      {
        path: '/requestion_detail', //问答详情
        name: 'ReQuestionDetail',
        component: () =>
          import('../views/ReQuestion/Index.vue')
      },
      {
        path: '/media_detail', //自媒体详情
        name: 'MediaDetail',
        component: () =>
          import('../views/Media/Detail/Index.vue')
      },
      {
        path: '/new_message', //自媒体中新增留言
        name: 'NewMessage',
        component: () =>
          import('../views/Media/NewMessage/Index.vue')
      },
      {
        path: '/invitation', //邀请
        name: 'Invitation',
        component: () =>
          import('../views/Invitation/Index.vue')
      },
      {
        path: '/special_more', //专题-更多
        name: 'SpecialMore',
        component: () =>
          import('../views/Special/More.vue')
      },
      {
        path: '/column_detail', //专栏
        name: 'ColumnDetail',
        component: () =>
          import('../views/Special/Column.vue')
      },
      {
        path: '/about_us', // 关于我们
        name: 'AboutUS',
        component: () =>
          import('../views/Static/AboutUS.vue')
      },
      {
        path: '/private', // 隐私政策
        name: 'Private',
        component: () =>
          import('../views/Static/Private.vue')
      },
      {
        path: '/protocol', // 用户协议
        name: 'Protocol',
        component: () =>
          import('../views/Static/Protocol.vue')
      },
      {
        path: '/copyright', // 版权声明
        name: 'Copyright',
        component: () =>
          import('../views/Static/Copyright.vue')
      },
      {
        path: '/sdk_list', // 第三方SDK目录
        name: 'SDKList',
        component: () =>
          import('../views/Static/SDKList.vue')
      },
      {
        path: '/score_rule', // 积分规则
        name: 'ScoreRule',
        component: () =>
          import('../views/Static/ScoreRule.vue')
      },
    ]
  },
]

const router = new VueRouter({
  routes
})

export default router
